import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { AnalyticsDashboard } from '_templates';
import { ROLES } from 'permission';
import { getUser } from 'store/selectors/authorizeSelectors';
import { analyticsFilter, type AnalyticsFilterBody } from 'actions/analyticActions';
import type { LabelValue } from 'store/reducers/types';
import { ReactComponent as CircularProgress } from 'dist/icons/loading.svg';

const EMPTY_ANALYTICS_FILTER: AnalyticsFilterBody = {
  candidates: [],
  companies: [],
  jobs: [],
  offices: [],
  openings_statuses: [],
  recruiters: [],
  recruiter_leads: [],
  services: [],
  team_leads: [],
  period: [moment(), moment()],
};

export const AnalyticsWrapper = () => {
  const user = useSelector(getUser);
  const isSH = user?.active_role?.name === ROLES.SERVICE_HEAD;
  const [loading, setLoading] = React.useState(isSH);
  const [defaultServices, setDefaultServices] = React.useState<LabelValue[]>([]);

  React.useEffect(() => {
    if (isSH) {
      analyticsFilter('services', EMPTY_ANALYTICS_FILTER, '')
        .then(setDefaultServices)
        .catch(() => setDefaultServices([]))
        .finally(() => setLoading(false));
    }
  }, []);

  return loading ? (
    <div style={{ paddingTop: 68, height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress width={40} height={40} />
    </div>
  ) : (
    <AnalyticsDashboard defaultServices={defaultServices} />
  );
};
